export default {module: 'File', window: 'File', component: 'downloadFileNoModal', element: null}